import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useZones({ active_only = false }) {
  const { getZones } = useApi();

  const { data, isLoading } = useQuery({
    queryKey: ["zones"],
    queryFn: () => getZones(active_only),
    select: (data) => {
      const zones = data?.data;

      const formatedZones = zones?.map((zone) => ({
        label: zone.description,
        value: zone.id,
      }));

      const zonesWithAll = [
        { label: "Todos", value: "all" },
        ...(formatedZones || []),
      ];

      return {
        zones: zonesWithAll,
        count: zones?.length || [],
      };
    },
  });

  return { data: data?.zones, count: data?.count, isLoading };
}
